const requestsCounter = ref(0);

export const activeRequests = computed(() => requestsCounter.value);

export function useWithRequestCounter(_axiosPromise) {
  ++requestsCounter.value;

  return _axiosPromise.finally(() => {
    decrementRequestCounter();
  });
}

export const incrementRequestCounter = () => ++requestsCounter.value;
export function decrementRequestCounter() {
  if (requestsCounter.value > 0) {
    --requestsCounter.value;
  }
}
